module.exports = __webpack_public_path__ + "static/media/apple-touch-icon-114x114.7c2a5dae.png";